import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  icon: '⏰',
  sin: '3-5 hs/semana planificando desde cero',
  con: '10 min/semana. El resto es enseñar.'
}, {
  icon: '😓',
  sin: 'Siempre los mismos ejercicios',
  con: '60+ clases distintas listas para dar'
}, {
  icon: '💸',
  sin: 'Alumnos que abandonan sin saber por qué',
  con: 'Progresión → retención visible'
}, {
  icon: '📋',
  sin: 'Sin evaluación ni seguimiento claro',
  con: 'Fichas y planillas listas desde el día 1'
}, {
  icon: '😨',
  sin: 'Alumno con patología = pánico',
  con: 'Patologías Pro → adaptación segura y confiada'
}, {
  icon: '👥',
  sin: 'Niveles mezclados = caos',
  con: 'Variaciones en 3 niveles para cada ejercicio'
}, {
  icon: '📱',
  sin: 'Sin sistema de comunicación',
  con: 'Flyers + scripts listos para WhatsApp e Instagram'
}, {
  icon: '💼',
  sin: 'Sin identidad profesional visible',
  con: 'Sistema que justifica cobrar lo que realmente valés'
}];
export function ComparisonTable() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <div className="text-center mb-6 md:mb-12" data-id="element-45">
          <h2 className="font-display text-4xl md:text-5xl text-navy-900 uppercase tracking-wide mb-4" data-id="element-46">
            MEGAPACK FUERZA MAYOR™
          </h2>
          <p className="text-xl text-navy-600 font-medium max-w-2xl mx-auto" data-id="element-47">
            El próximo lunes podés volver a improvisar la clase con tus alumnos
            mayores. O podés entrar al centro con todo resuelto desde hoy.
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-navy-100 overflow-hidden" data-id="element-48">
          <div className="grid grid-cols-2 bg-navy-900 text-white" data-id="element-49">
            <div className="p-4 md:p-6 text-center font-bold text-lg md:text-xl border-r border-navy-700 bg-red-900/20" data-id="element-50">
              SIN FUERZA MAYOR
            </div>
            <div className="p-4 md:p-6 text-center font-bold text-lg md:text-xl bg-green-900/20 text-gold" data-id="element-51">
              CON FUERZA MAYOR
            </div>
          </div>

          <div className="divide-y divide-navy-100" data-id="element-52">
            {rows.map((row, idx) => <div key={idx} className="grid grid-cols-2 relative" data-id="element-53">
                {/* Center Icon */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white border border-navy-100 rounded-full flex items-center justify-center text-sm z-10 shadow-sm hidden md:flex" data-id="element-54">
                  {row.icon}
                </div>

                <div className="p-4 md:p-6 bg-red-50/30 flex items-center gap-3 border-r border-navy-100" data-id="element-55">
                  <X className="text-danger shrink-0" size={20} data-id="element-56" />
                  <span className="text-navy-800 font-medium text-sm md:text-base" data-id="element-57">
                    {row.sin}
                  </span>
                </div>

                <div className="p-4 md:p-6 bg-green-50/30 flex items-center gap-3" data-id="element-58">
                  <Check className="text-green-600 shrink-0" size={20} data-id="element-59" />
                  <span className="text-navy-900 font-bold text-sm md:text-base" data-id="element-60">
                    {row.con}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}